var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EditarReciboComponent',{attrs:{"recibo_id":_vm.recibo.id},on:{"guardado":function($event){return _vm.volver()}}})}
var staticRenderFns = []

export { render, staticRenderFns }